// react
import { useContext } from "react";
// libs
import { motion } from "framer-motion";
// components
import { Container } from "../Container";
import { Box } from "../Box";
import { Chip } from "../Chip";
import { FlexContainer, FlexItem } from "../Flex";
import { Text } from "../Text";
import ATHeroImage from "./ATHeroImage";
// context
import { ArtifactViewSelectionContext } from "../../context/ArtifactViewSelectionContext";
// other
import { ArtifactTheme } from "../../models/client";

interface ATHeroProps {
  artifactTheme: ArtifactTheme;
}

function ATHero({ artifactTheme }: ATHeroProps) {
  const { setArtifactById } = useContext(ArtifactViewSelectionContext);

  return (
    <>
      <Box mb={[4, null, 5, null, 6]}>
        <FlexContainer
          flexWrap="wrap"
          alignItems="center"
          justifyContent="space-between"
        >
          <FlexItem
            flex={["0 0 100%", null, null, "0 0 45%", "0 0 53%"]}
            mb={[32, null, null, 0]}
          >
            <ATHeroImage
              artifact={artifactTheme.heroArtifact}
              onClick={() => setArtifactById(artifactTheme.heroArtifact.id)}
            />
          </FlexItem>
          <FlexItem flex={["0 0 100%", null, null, "0 0 50%", "0 0 42%"]}>
            <Container pl={[3, 4, null, 0]}>
              <Box mb={3} maxWidth={800}>
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.6, delay: 1.6 }}
                >
                  <Text variant="h1">{artifactTheme.name}</Text>
                </motion.div>
              </Box>
              <Box mb={3}>
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.6, delay: 1.7 }}
                >
                  <Chip color={artifactTheme.dateTag.color} size="lg">
                    <Text variant="h4">{artifactTheme.dateTag.label}</Text>
                  </Chip>{" "}
                </motion.div>
              </Box>
              <Box maxWidth={600}>
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.6, delay: 1.8 }}
                >
                  <Text variant="body">{artifactTheme.summary}</Text>
                </motion.div>
              </Box>
            </Container>
          </FlexItem>
        </FlexContainer>
      </Box>
    </>
  );
}

export default ATHero;
